import { skipToken, useQuery } from "@tanstack/react-query"
import { getLocalWeather } from "./weather"
import { weatherKeys } from "./queryKeys"

export const useGetLocalWeatherQuery = (zipcode: string | undefined) => {
  return useQuery({
    queryKey: weatherKeys.detail(zipcode),
    queryFn: zipcode ? () => getLocalWeather(zipcode) : skipToken,
    staleTime: 5 * 60000, // 5 minutes
    retry: false,
  })
}
